import { useState, useEffect, useRef } from 'react';
import { getCategories, getCachedCategories } from '../firebase/categories';

/**
 * Hook for fetching categories with real-time updates
 * Uses cache-first loading with background refresh (no realtime listeners)
 */
export const useCategories = () => {
  const cached = getCachedCategories();
  const [categories, setCategories] = useState(cached);
  const [loading, setLoading] = useState(cached.length === 0);
  const [error, setError] = useState(null);
  const mountedRef = useRef(true);

  useEffect(() => {
    mountedRef.current = true;
    setError(null);

    // Background refresh from Firestore (one-time)
    getCategories({ forceRefresh: true })
      .then((categoriesData) => {
        if (mountedRef.current) {
          setCategories(categoriesData);
          setLoading(false);
          setError(null);
        }
      })
      .catch((err) => {
        if (mountedRef.current) {
          setError(err?.message || 'Failed to load categories');
          setLoading(false);
        }
      });

    return () => {
      mountedRef.current = false;
    };
  }, []);

  return { categories, loading, error };
};
